import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Divider from '@material-ui/core/Divider'
import CorporateCustomers from 'images/icons/corporate_customers.svg'
import PrivateCustomers from 'images/icons/private_customers.svg'
import InfoOnUnknownPerson from 'pdf/smp/Muster_Auskunft_zu_unbekannt_verzogener_Person.pdf'
import CreditCheck from 'pdf/smp/Muster_Bonitaetspruefung_bei_Auftraggebern_fuer_die_Zahlungsart_auf_Rechnung.pdf'
import CreditInquiries from 'pdf/smp/Muster_Bonitaetspruefung_vor_Abschluss_eines_Mietvertrages.pdf'
import CreditCheckBeforeApproval from 'pdf/smp/Muster_Bonitaetspruefung_vor_Verwalterzustimmung_nach_§_12_WEG.pdf'
import CompactInformation from 'pdf/smp/Muster_SCHUFA-Kompaktauskunft.pdf'
import BriefInformation from 'pdf/smp/Muster_SCHUFA-Kurzauskunft.pdf'
import FullInformation from 'pdf/smp/Muster_SCHUFA-Vollauskunft.pdf'
import React, { FC } from 'react'
import { scopedTranslation } from 'src/helpers'

import { useStyles } from './InformationCard.styles'
import { InformationAccordionOptions, InformationSection } from './InformationCardSection/InformationSection'

interface InformationCardProps {
  isPreview?: boolean
}

const { t } = scopedTranslation('component.smp.information_page.card')

const companyClientsInfo: InformationAccordionOptions[] = [
  {
    headline: t('brief_information.headline'),
    link: BriefInformation,
    bulletPoints: [
      t('brief_information.first_bullet'),
    ],
  },
  {
    headline: t('compact_information.headline'),
    link: CompactInformation,
    bulletPoints: [
      t('compact_information.first_bullet'),
      t('compact_information.second_bullet'),
    ],
  },
  {
    headline: t('full_information.headline'),
    link: FullInformation,
    bulletPoints: [
      t('full_information.first_bullet'),
      t('full_information.second_bullet'),
    ],
  },
]

const privateClientsInfo: InformationAccordionOptions[] = [
  {
    headline: t('credit_check.headline'),
    link: CreditCheck,
    bulletPoints: [
      t('credit_check.first_bullet'),
      t('credit_check.second_bullet'),
    ],
  },
  {
    headline: t('credit_inquiries.headline'),
    link: CreditInquiries,
    bulletPoints: [
      t('credit_inquiries.first_bullet'),
    ],
  },
  {
    headline: t('credit_check_before_approval.headline'),
    link: CreditCheckBeforeApproval,
    bulletPoints: [
      t('credit_check_before_approval.first_bullet'),
    ],
  },
  {
    headline: t('info_on_unknown_person.headline'),
    link: InfoOnUnknownPerson,
    bulletPoints: [
      t('info_on_unknown_person.first_bullet'),
    ],
  },
]

export const InformationCard: FC<InformationCardProps> = ({
  isPreview,
}) => {
  const classes = useStyles()

  return (
    <Card className={ classes.card }>
      <CardContent>
        <InformationSection
          customerIcon={ CorporateCustomers }
          customerType={ t('customer_company') }
          price={ t('price_company') }
          infoAccordions={ companyClientsInfo }
          isPreview={ isPreview ?? false }
        />
        <Divider className={ classes.divider } />
        <InformationSection
          customerIcon={ PrivateCustomers }
          customerType={ t('customer_private') }
          price={ t('price_private') }
          infoAccordions={ privateClientsInfo }
          isPreview={ isPreview ?? false }
        />
      </CardContent>
    </Card>
  )
}
